import { Injectable } from '@angular/core';

@Injectable()
export class CsvHelperService {

  private fileReader: FileReader;

  /**
   * The function which is called after one line of csv is read.
   */
  private addInfoToTableFunction: Function;

  constructor() {
    this.fileReader = new FileReader();
    this.fileReader.addEventListener('load', this.readCsvFile.bind(this));
  }


  openReadBuffer(file, addInfoToTableFunction) {
    const fileExt = file.name.substr(-3);
    if (fileExt.toLowerCase() !== 'csv') {
      alert('Only csv files allowed.');
    } else {
      this.addInfoToTableFunction = null;
      this.addInfoToTableFunction = addInfoToTableFunction;
      this.fileReader.abort();
      this.fileReader.readAsText(file);
    }
  }

  private readCsvFile() {
    const fileContent = this.fileReader.result;
    const lines = fileContent.split('\n');
    if (this.checkForUniformity(lines)) {
      lines.forEach((line, index) => {
        // check for header and empty last line.
        if (index === 0 || (index === lines.length - 1 && line === '')) {
          return;
        } else {
          this.extractInfo(line);
        }
      });
    } else {
      alert('Not a valid csv file.');
    }
  }

  /**
   * Extracts the values of a line in a csv file.
   */
  private extractInfo(csvLine) {
    const csvValues: string[] = csvLine.split(',');
    for (let i = 0; i < csvValues.length; i++) {
      let strLength = csvValues[i].length;
      if (csvValues[i].charCodeAt(csvValues[i].length - 1) === 13) {
        strLength = csvValues[i].length - 1;
      }
      if (csvValues[i].indexOf('"') === 0 && csvValues[i].lastIndexOf('"') === strLength - 1) {
        csvValues[i] = this.extractDataFromQuotes(csvValues[i]);
      }
    }
    const firstName = csvValues[0];
    const lastName = csvValues[1];
    if (csvValues[2].charCodeAt(csvValues[2].length - 1) === 13) {
      csvValues[2] = csvValues[2].substring(0, csvValues[2].length - 1);
    }
    const email = csvValues[2];
    this.addInfoToTableFunction(firstName, lastName, email);
  }

  /**
   * Checks whether lines have equal no of comma separated values.
   */
  private checkForUniformity(lines) {
    let noOfValuesPrev = null;
    let isUniform = true;
    let index = 0;
    for (const csvLine of lines) {
      const currValue = csvLine.split(',');
      const noOfValuesCurr = currValue.length;
      if (index === lines.length - 1 && csvLine === '') {
        break;
      }
      if (noOfValuesPrev === null) {
        noOfValuesPrev = noOfValuesCurr;
        index += 1;
        continue;
      }
      if (noOfValuesCurr !== noOfValuesPrev) {
        isUniform = false;
        break;
      }
      noOfValuesPrev = noOfValuesCurr;
      index += 1;
    }
    return isUniform;
  }

  private extractDataFromQuotes(fieldValue) {
    const allCharsInQuote = new RegExp(/[^"]([.\n\s"])*[^"]/, 'g');
    let matchedSeq = allCharsInQuote.exec(fieldValue);
    let wholeSeq = '';
    while (matchedSeq !== null) {
      wholeSeq += matchedSeq[0];
      matchedSeq = allCharsInQuote.exec(fieldValue);
    }
    return wholeSeq;
  }

}





// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/csv-helper-service.service.ts